import type { RouteConfig } from 'vue-router'
import { ROUTE_NAMES, shortCircuitPath } from './routeNames.const'
import { ENDPOINTS } from '@shared/utils'

export const routesShortCircuit = {
  path: shortCircuitPath,
  name: ROUTE_NAMES.shortCircuit,
  component: () =>
    import(
      /* webpackChunkName: "ShortCircuit" */ 'src/pages/ShortCircuit/ShortCircuit.vue'
    ),
  redirect: ENDPOINTS.shortCircuit(
    ROUTE_NAMES.shortCircuitSteps.chooseOperation,
  ),
  children: [
    {
      path: ROUTE_NAMES.shortCircuitSteps.chooseOperation,
      name: ROUTE_NAMES.shortCircuitSteps.chooseOperation,
      component: () =>
        import(
          /* webpackChunkName: "ShortCircuit" */ 'src/pages/ShortCircuit/steps/ShortCircuitChooseOperation.vue'
        ),
    },
    {
      path: ROUTE_NAMES.shortCircuitSteps.configuration,
      name: ROUTE_NAMES.shortCircuitSteps.configuration,
      component: () =>
        import(
          /* webpackChunkName: "ShortCircuit" */ 'src/pages/ShortCircuit/steps/ShortCircuitConfiguration.vue'
        ),
    },
    {
      path: ROUTE_NAMES.shortCircuitSteps.financialPivot,
      name: ROUTE_NAMES.shortCircuitSteps.financialPivot,
      component: () =>
        import(
          /* webpackChunkName: "ShortCircuit" */ 'src/pages/PatrimonyDevelopment/FinancialPivot/FinancialPivot.vue'
        ),
    },
    {
      path: ROUTE_NAMES.shortCircuitSteps.productSelection,
      name: ROUTE_NAMES.shortCircuitSteps.productSelection,
      component: () =>
        import(
          /* webpackChunkName: "ShortCircuit" */ 'src/pages/ShortCircuit/steps/ProductSelection.vue'
        ),
    },
  ],
} satisfies RouteConfig
